export default __webpack_public_path__ + "static/course6-864940d2d4096c77eee0caf78024abdc.jpg";